import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export const archiveProductDraft = async (
  id: number,
  archived: boolean
): Promise<void> => {
  try {
    await apiService.patch(`/rfqs/${id}`, { archived });
  } catch (error) {
    throw handleAxiosError(error);
  }
};
